
import React, { useState } from 'react';

const faqs = [
  { q: "How long does installation take?", a: "Typically, a residential installation takes 2-3 days, while industrial projects vary from 2-4 weeks depending on scale and complexity." },
  { q: "What is the warranty on solar panels?", a: "We provide a premium 25-year performance warranty on all our Tier 1 solar panels and a comprehensive 10-year workmanship guarantee." },
  { q: "Can I monitor energy production?", a: "Yes, our proprietary AI-powered mobile app provides real-time monitoring, predictive analytics, and performance alerts for all your installations." },
  { q: "Do you offer financing?", a: "We offer multiple flexible financing options including zero-down leasing, low-interest government-backed loans, and custom corporate plans." }
];

const FAQ: React.FC = () => {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="max-w-[1440px] mx-auto px-6 md:px-20 grid lg:grid-cols-[1.2fr_1fr] gap-10 lg:gap-20 items-start">
        <div className="pt-4 md:pt-10">
          <div>
            <h2 className="fluid-heading-lg font-extrabold leading-tight mb-2 text-[#1E1E1E]">Commonly asked</h2>
            <h2 className="fluid-heading-lg font-extrabold leading-tight mb-8 md:mb-10 text-gray-400">questions</h2>
          </div>
          
          <div className="space-y-3 md:space-y-4">
            {faqs.map((faq, i) => (
              <div 
                key={i} 
                className={`border border-gray-100 rounded-[0.4rem] md:rounded-[0.8rem] transition-colors duration-500 ${open === i ? 'bg-[#F8FAFA] border-emerald-500/20 shadow-sm' : 'bg-white hover:border-emerald-200'}`}
              >
                <button 
                  onClick={() => setOpen(open === i ? null : i)}
                  className="w-full flex items-center justify-between p-6 md:p-8 text-left group outline-none cursor-pointer"
                  aria-expanded={open === i}
                >
                  <span className={`font-bold text-lg md:text-xl transition-colors duration-300 ${open === i ? 'text-[#1E1E1E]' : 'text-slate-600 group-hover:text-emerald-500'}`}>
                    {faq.q}
                  </span>
                  <div className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center transition-all duration-500 flex-shrink-0 ${open === i ? 'bg-emerald-500 text-white rotate-180' : 'bg-gray-50 text-slate-400'}`}>
                    <svg className="w-4 h-4 md:w-5 md:h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M19 9l-7 7-7-7" />
                    </svg>
                  </div>
                </button>
                <div 
                  className={`grid transition-all duration-500 ease-in-out ${open === i ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}
                >
                  <div className="overflow-hidden">
                    <div className="px-6 pb-6 md:px-8 md:pb-8 text-slate-500 text-base md:text-lg leading-relaxed">
                      {faq.a}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative rounded-[0.4rem] md:rounded-[0.8rem] overflow-hidden aspect-[3/4] shadow-[0_50px_100px_-20px_rgba(0,0,0,0.15)] group">
          <img 
            src="https://i.imgur.com/WzDn7KP.jpeg?q=60&w=1000" 
            className="w-full h-full object-cover transition-transform duration-[2s] group-hover:scale-105" 
            alt="FAQ support" 
            loading="lazy"
          />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/10 transition-colors"></div>
          <div className="absolute bottom-6 left-6 right-6 md:bottom-10 md:left-10 md:right-10 p-6 md:p-10 bg-white/10 backdrop-blur-2xl border border-white/20 rounded-[0.4rem] md:rounded-[0.8rem] transform translate-y-4 group-hover:translate-y-0 transition-transform">
             <p className="text-white font-extrabold text-xl md:text-2xl mb-2 leading-tight">Still have questions?</p>
             <p className="text-white/80 text-xs md:text-sm mb-6 md:mb-8 leading-relaxed">Our certified energy experts are ready to help you calculate your savings today.</p>
             <button className="w-full bg-white text-black text-sm font-black px-6 md:px-8 py-3.5 md:py-4 rounded-full hover:bg-emerald-500 hover:text-white transition-all transform hover:scale-105 active:scale-95 shadow-xl">
               Schedule Free Consultation
             </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
